import React, { useMemo } from "react";
import { Card, CardBody } from "../../../../../_metronic/_partials/controls";
import NewBreadCrumbs from "../../../../../_metronic/layout/components/subheader/components/NewBreadCrumbs";
import NotAuthorized from "../../../../../_metronic/_partials/widgets/NotAuthorized";
import { shallowEqual, useSelector } from "react-redux";
import { canAccessDebtCollectionFlow } from "./debtCollectionRoles";
import { DebtCollectionFilter } from "./debt-collection-filter/DebtCollectionFilter";
import { DebtCollectionTable } from "./debt-collection-table/DebtCollectionTable";

/**
 * Card layout for debt collection list with breadcrumbs and permission gate.
 * @returns {JSX.Element} Filter/table or not-authorized content.
 */
export function DebtCollectionCard() {
  const { permission, user } = useSelector(
    (state) => ({
      permission: state.auth.permission,
      user: state.auth.user,
    }),
    shallowEqual,
  );
  const roles = user?.roles;

  const isDebtCollectionAllowed = useMemo(
    () => canAccessDebtCollectionFlow(roles),
    [roles],
  );

  const canView = isDebtCollectionAllowed && permission?.setting?.view;

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <NewBreadCrumbs title="Debt Collection" />
        <div />
      </div>
      <Card>
        <CardBody>
          {canView ? (
            <>
              <DebtCollectionFilter />
              <DebtCollectionTable />
            </>
          ) : (
            <NotAuthorized />
          )}
        </CardBody>
      </Card>
    </>
  );
}
